import React, { useState } from "react";
import Toggle from "../toggle.js";
import Notification from "./Notification";
import { MDBRow, MDBCol } from "mdbreact";
import axios from "../../helpers/axios";
import { useSelector, useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import { ENDPOINT_NOTIFICATIONS } from "../../helpers/endpoints";
export default function HeaderSideBar() {
  const { userId, socket } = useSelector(state => ({
    ...state.User,
    ...state.Socket
  }));
  const [notifications, setNotifications] = useState();
  const alert = useAlert();
  const dispatch = useDispatch();
  React.useEffect(() => {
    axios
      .get(ENDPOINT_NOTIFICATIONS(userId))
      .then(({ data }) => setNotifications(data));
  }, [userId]);
  const update = async () => {
    const { data } = await axios.get(ENDPOINT_NOTIFICATIONS(userId));
    if (data) setNotifications(data);
  };
  React.useEffect(() => {
    if (socket && notifications) {
      socket.on("notification", notification => {
        setNotifications([notification, ...notifications]);
        alert.info("new message");
      });
    }
  }, [alert, notifications, socket]);
  const toggle = () => {
    dispatch({
      type: "TOGGLE"
    });
  };
  return (
    <header>
      <MDBCol size="9" className="logo">
        <img src={require("./../../assets/img/socket-io.svg")} alt="" />
        <h1> Rest-Socket </h1>
      </MDBCol>

      <MDBCol size="2">
        {notifications && (
          <Notification update={update} notifications={notifications} />
        )}
      </MDBCol>
      <MDBCol size="1">
        <Toggle onClick={toggle} />
      </MDBCol>
    </header>
  );
}
